import {Component, Input, inject} from '@angular/core';
import {trigger, transition, style, animate} from '@angular/animations';
import {FormGroup} from "@angular/forms";
import {FormItem} from "../form-section/form-section-interface";
import {TranslateModule} from "@ngx-translate/core";
import {FormErrorService} from '../../../../services/form-error.service';

@Component({
  selector: 'app-error-handler',
  standalone: true,
  imports: [
    TranslateModule,
  ],
  templateUrl: './error-handler.component.html',
  animations: [
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-4px)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('120ms ease-in', style({ opacity: 0, transform: 'translateY(-4px)' }))
      ])
    ])
  ]
})
export class ErrorHandlerComponent {
  @Input() formGroup: FormGroup;
  @Input() fieldData: FormItem;
  @Input() isFormSubmitted = false;

  private readonly formErrorService = inject(FormErrorService);

  shouldShow(): boolean {
    if (!this.formGroup || !this.fieldData) return false;
    return this.formErrorService.shouldShowErrors(this.formGroup, {
      controlName: this.fieldData.controlName,
      minLength: this.fieldData.minLength,
      maxLength: this.fieldData.maxLength,
      errorMsg: this.fieldData.errorMsg,
    }, this.isFormSubmitted);
  }

  messages(): Array<{ key: string; params?: Record<string, unknown>; textOverride?: string }>{
    if (!this.formGroup || !this.fieldData) return [];
    return this.formErrorService.getErrorMessages(this.formGroup, {
      controlName: this.fieldData.controlName,
      minLength: this.fieldData.minLength,
      maxLength: this.fieldData.maxLength,
      errorMsg: this.fieldData.errorMsg,
    });
  }
}
